export const OFFERS_HUB_FIELD_LABELS = {
  brandName: 'Brand Name',
  ctaLabel: 'CTA Label',
  ctaUrl: 'CTA URL',
  description: 'Description',
  eligibleRegions: 'Eligible Regions',
  endAt: 'Ends At',
  imageId: 'Image ID',
  industry: 'Industry',
  label: 'Label',
  logoImageId: 'Logo Image ID',
  offerTag: 'Offer Tag',
  startAt: 'Starts At',
  title: 'Title',
  urgencyType: 'Urgency Type',
} as const;

export const OFFERS_HUB_CTA_URL_HELPER_TEXT = 'External: full https:// URL.\nInternal: start with / and omit region code.';

export const OFFERS_HUB_ELIGIBLE_REGIONS_HELPER_TEXT = 'Leave empty for all site regions';

export const OFFERS_HUB_LOGO_IMAGE_ID_HELPER_TEXT = 'Prefer logo assets with no whitespace.';

export type OffersHubFieldLabelKey = keyof typeof OFFERS_HUB_FIELD_LABELS;

export function fieldLabel(field: OffersHubFieldLabelKey): string {
  return OFFERS_HUB_FIELD_LABELS[field];
}
